import React from 'react';
import styled from 'styled-components';
import {makeStyles, Tooltip} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    tooltipWrap: {
        background: theme.palette.common.white,
        borderRadius: 3,
        border: 0,
        color: '#1B191E',
        padding: '16px 20px',
        boxShadow: '0px 4px 4px rgba(0, 0, 0, .25)',
        maxWidth: 210
    }
}));

export interface TextTooltipProps {
    children: React.ReactElement;
    text?: string;
}

const ChildrenWrapper = styled.div`
    cursor: pointer;
    .ue-rich-text {
        border-bottom: 2px dotted ${(p) => p.theme.palette.text.secondary};
    }
    width: fit-content;
`;

export const TooltipWrap = ({children, text}: TextTooltipProps): JSX.Element => {
    const classes = useStyles();

    if (!text) {
        return children;
    }
    return (
        <Tooltip
            title={text}
            arrow
            placement="bottom"
            classes={{tooltip: classes.tooltipWrap}}
            enterTouchDelay={0}>
            <ChildrenWrapper>{children}</ChildrenWrapper>
        </Tooltip>
    );
};
